// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"79539569","362":"8ff7d780","410":"08beef06","462":"40a18858","487":"acaef30d","761":"0521ae1c","787":"3d11092c","810":"8cc54db2","830":"fbd92925"}[chunkId] + ".chunk.js";
};